import { find } from 'lodash';

function findWorkAddressOrFirstAddress(addresses = []) {
  return find(addresses, { address_type: 'work' }) || (addresses && addresses[0]);
}

export default findWorkAddressOrFirstAddress;
